/*eslint no-array-constructor: "off"*/
/*eslint react-hooks/exhaustive-deps: "off"*/


import useCustomRouter from "hooks/useCustomRouter";
import useCustomToast from "hooks/useCustomToasts";
import useQueryParams from "hooks/useQueryParams";
import React, { useEffect } from "react";

import Loading from "wrappers/Loading";

// import { enviar } from "./funcionesPrueba";

const RecuperarSegukids = () => {
  const { addWarningToast } = useCustomToast();

  const { id: idCotizacion } = useQueryParams();

  const history = useCustomRouter();  

  const getData = async () => {debugger
    if (idCotizacion) {
      history.push(`/kids/planes?idCotizacion=${idCotizacion}`);
    } else {
      addWarningToast("Ha ocurrido un problema al recuperar la cotización");
      history.goBack();
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <Loading loading={true} message="Recuperando...">
      <h1>Recuperando...</h1>
    </Loading>
  );
};
export default RecuperarSegukids;
